import styled from 'styled-components';
import React, { useState, useImperativeHandle, memo } from 'react';
import { forwardRef } from 'react';

const CustomAlert = forwardRef((_, ref) => {
    const [isOpen, setIsOpen] = useState(false);
    const [message, setMessage] = useState('');

    useImperativeHandle(ref, () => ({
        showAlert: (msg) => {
            // console.log('type of mss : ', typeof msg);
            // console.log(message.includes('\\n'));
            setMessage(msg);
            setIsOpen(true);
        },
    }));

    const closeAlert = () => setIsOpen(false);

    const isString = typeof message === 'string' ? true : false;

    return isOpen ? (
        <Overlay>
            <ModalContainer>
                <Message>
                    {/* {message.split('\\n').map((line, index) => (    // 한참 개고생했다. '\n'이 아니라 '\\n'으로 해야 한다.
                        <React.Fragment key={index}>
                            {line}
                            <br />
                        </React.Fragment>
                    ))} */}
                    {isString && message.split('\\n').map((line, index) => (
                        <React.Fragment key={index}>
                            {line}
                            <br />
                        </React.Fragment>
                    ))}
                    {!isString && <>{message}</> }
                </Message>
                <ButtonContainer>
                    <Button onClick={closeAlert}>OK</Button>
                </ButtonContainer>
            </ModalContainer>
        </Overlay>
    ) : null;
});

export default memo(CustomAlert);

const Overlay = styled.div`
    position: fixed;
    inset: 0;
    background-color: rgba(31, 41, 55, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 50;
`;

const ModalContainer = styled.div`
    // width: 480px;
    max-width: 50%;
    min-width: 480px;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    padding: 32px;
    position: relative;
    white-space: pre-line;
`;

const Message = styled.p`
    white-space: pre-line;
`;

const ButtonContainer = styled.div`
    margin-top: 48px;
    display: flex;
    justify-content: flex-end;
`;

const Button = styled.button`
    background-color: #3b82f6;
    color: white;
    padding: 8px 16px;
    border-radius: 4px;
    border: none;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
        background-color: #2563eb;
    }
`;
